import { IPagamentos } from '../../../types/tables/IPagamentos';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de pagamentos efetivados com isolamento multi-tenant
 * Gerencia pagamentos confirmados via sistema de cobrança
 */
export class PagamentosService extends BaseMultiTenantService<IPagamentos> {
     constructor() {
          super(
               'pagamentos', 
               ['numero_pagamento', 'nome_pagador'],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca pagamento por número
      */
     async getByNumero(organizationId: number, numeroPagamento: number) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('numero_pagamento', numeroPagamento)
               .single();
     }

     /**
      * Busca pagamentos por estado
      */
     async getByEstado(organizationId: number, codigoEstado: number) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_pagamento', codigoEstado)
               .order('timestamp_pagamento', { ascending: false });
     }

     /**
      * Busca pagamentos efetivados
      */
     async getEfetivados(organizationId: number) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_pagamento', 200) // EFETIVADO
               .order('timestamp_pagamento', { ascending: false });
     }

     /**
      * Busca pagamentos cancelados
      */
     async getCancelados(organizationId: number) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_pagamento', 207) // CANCELADO
               .order('timestamp_pagamento', { ascending: false });
     }

     /**
      * Busca por código de conciliação
      */
     async getByConciliacao(organizationId: number, codigoConciliacao: string) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_conciliacao_solicitacao', codigoConciliacao)
               .order('timestamp_pagamento', { ascending: false });
     }

     /**
      * Busca pagamentos por período
      */
     async getByPeriodo(organizationId: number, dataInicio: string, dataFim: string) {
          return await this.client
               .from('pagamentos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .gte('timestamp_pagamento', dataInicio)
               .lte('timestamp_pagamento', dataFim)
               .order('timestamp_pagamento', { ascending: false });
     }

     /**
      * Calcula total de pagamentos por período
      */
     async getTotalByPeriodo(organizationId: number, dataInicio: string, dataFim: string) {
          return await this.client
               .from('pagamentos')
               .select('valor_liquido_recebedor.sum()')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_pagamento', 200) // Apenas efetivados
               .gte('timestamp_pagamento', dataInicio)
               .lte('timestamp_pagamento', dataFim);
     }
}
